import React from "react";
import {Text, View, StyleSheet, Image, useWindowDimensions, TouchableOpacity} from 'react-native';
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";
import Config from '../../Config';


import * as Linking from 'expo-linking';


const Update = ({navigation})=>{

    const bazar = ()=>{
        Linking.openURL('https://cafebazaar.ir/app/com.himoralanguagecenter.app')
    }
    const direct = ()=>{
        Linking.openURL('https://app.himoralanguagecenter.com/landing')
    }

    return (
        <View style={styles.container}>
            <Image
                resizeMode={'stretch'}
                fadeDuration={999}
                style={{
                    width : RFValue(400),
                    height :RFValue(400),

                }}
                source={require('../../assets/splash-icon.png')}
            />
            <Text style={styles.text}>
                بروزرسانی  جدید رسید !
            </Text>

            <TouchableOpacity
                disabled={false}
                onPress={bazar}
                style={styles.button}
            >
                <Text style={styles.buttonText}>   دانلود از کافه بازار </Text>
            </TouchableOpacity>

            <TouchableOpacity
                disabled={false}
                onPress={direct}
                style={styles.button}
            >
                <Text style={styles.buttonText}> دانلود مستقیم</Text>
            </TouchableOpacity>



        </View>
    );
}

export default Update;
const styles = StyleSheet.create({
    text : {
        fontFamily : 'ykb',
        color: Config.secondcolor,
        fontSize : RFValue(14),
    },


    container: {
        flex: 1,
        backgroundColor : Config.maincolor,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonText: {
        fontFamily: "yk",
        fontSize: RFValue(16),
        color: Config.maincolor,
    },
    button: {
        backgroundColor: Config.secondcolor,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        marginTop: RFValue(20),
        borderRadius: RFValue(10),
        height: RFValue(40),
        width: '80%',
    },
})